import { createSentryEmbed } from '@mono-activities/sentry-embed'

// Read `document.currentScript` synchronously at module-eval time — once this file's
// top-level code has run, `currentScript` is no longer the UMD bundle's script tag.
const scriptUrl = (typeof document !== 'undefined' ? (document.currentScript as HTMLScriptElement | null) : null)?.src

const release = import.meta.env.VITE_SENTRY_RELEASE || import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA || undefined

const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development'

const embed = createSentryEmbed({
  appName: 'tme',
  dsn: 'https://49a9ed818b65bd8bac07e78fc2f35434@o4507255733813248.ingest.us.sentry.io/4509447986020352',
  environment,
  release,
  scriptUrl,
  beforeSend: (event, hint) => {
    if (event.exception && environment !== 'production') {
      console.error('[tme] Sentry capturing exception:', hint.originalException)
    }
    return event
  },
})

export const sentryScope = embed.scope
export const { ErrorBoundary, captureException, captureMessage, withScope, reportError } = embed

if (environment !== 'production') {
  console.info('[tme] Sentry client initialized')
}
